var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategySvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9,18.7h-8.1c-1.8,0-3.2,1.4-3.2,3.2V22v1.9h-7.5V8.1c0-0.5-0.5-1-1-1H16.6V5.2c0-1.8-1.4-3.2-3.2-3.2 H5.3C3.6,2,2.1,3.4,2.1,5.2v8.1c0,1.8,1.4,3.2,3.2,3.2h8.1c1.8,0,3.2-1.4,3.2-3.2v-1.9H24v12.5h-7.4V22v0c0-1.8-1.4-3.2-3.2-3.2H5.3 c-1.8,0-3.2,1.4-3.2,3.2v0v8v0c0,1.8,1.4,3.2,3.2,3.2h8.1c1.8,0,3.2-1.4,3.2-3.2v0v-1.9H24v12.5h-7.4v-1.8c0-1.8-1.4-3.2-3.2-3.2 H5.3c-1.8,0-3.2,1.4-3.2,3.2v8.1c0,1.8,1.4,3.2,3.2,3.2h8.1c1.8,0,3.2-1.4,3.2-3.2v-1.9h10.6c0.6,0,1-0.6,1-1V28.2h7.5v1.8V30 c0,1.8,1.4,3.2,3.2,3.2h8.1c1.8,0,3.2-1.4,3.2-3.2v-0.1V22v-0.1C50.1,20.1,48.7,18.7,46.9,18.7z M12.5,12.4H6.2V6h6.3V12.4z M12.5,22.8v6.3H6.2v-6.3H12.5z M12.5,46H6.2v-6.3h6.3V46z M46.1,22.8v6.3h-6.3v-6.3H46.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategySvgrepoCom);
export default __webpack_public_path__ + "static/media/strategy-svgrepo-com.435778c9824a3a79f285cc3a065ece71.svg";
export { ForwardRef as ReactComponent };